jQuery(document).on('submit', '#custom_request_purchase', function(e) {
    e.preventDefault();

    // Format number with commas
    function formatPrice(price) {
        return price.toLocaleString('en-AU');
    }

    // Read products from samitaRFQ localStorage keys
    var productList = [];
    var i = 1;

    while (true) {
        var itemRaw = localStorage.getItem('shop-nielsen.myshopify.com/samitaRFQ/group_0.item_' + i);
        if (!itemRaw) break;

        var item = JSON.parse(itemRaw);
        productList.push({
            handle:        item.handle        || '',
            id:            item.product_id    || '',
            image:         item.image         || '',
            price:         formatPrice(item.price / 100),
            quantity:      item.qty,
            title:         decodeURIComponent(item.name),
            total:         formatPrice((item.qty * item.price) / 100),
            url:           item.product_url   || '',
            variant_id:    item.variant_id    || '',
            variant_sku:   item.sku           || '',
            variant_title: item.variant_title || '',
            vendor:        item.vendor        || ''
        });
        i++;
    }

    // Console log all fields
    console.group('Form Fields');
    console.log('Name:',    jQuery('#cname').val());
    console.log('Email:',   jQuery('#cemail').val());
    console.log('Phone:',   jQuery('#cphone').val());
    console.log('State:',   jQuery('#cstate').val());
    console.log('Enquiry:', jQuery('#enquiry').val());
    console.group('Products');
    productList.forEach(function(p, index) {
        console.log('Product ' + (index + 1) + ':',
            p.title,
            '| Qty:',      p.quantity,
            '| Price:',    p.price,
            '| Total:',    p.total,
            '| Variant:',  p.variant_title,
            '| Vendor:',   p.vendor
        );
    });
    console.groupEnd();
    console.groupEnd();

    var errormsg = '',
        cname    = jQuery('#cname'),
        cemail   = jQuery('#cemail'),
        cphone   = jQuery('#cphone'),
        cstate   = jQuery('#cstate'),
        form     = jQuery('#custom_request_purchase');

    if (cname.val() == '') {
        errormsg += "<strong>Error!</strong> Name is required.<br/>";
    }
    if (cstate.val() == '') {
        errormsg += "<strong>Error!</strong> State is required.<br/>";
    }
    if (cemail.val() == '') {
        errormsg += "<strong>Error!</strong> Email is required.<br/>";
    } else {
        if (!isEmail(cemail.val())) {
            errormsg += "<strong>Error!</strong> Invalid email<br/>";
        }
    }
    if (cphone.val() == '') {
        errormsg += "<strong>Error!</strong> Phone is required.";
    }

    if (errormsg != '') {
        errormsg = '<div class="alert alert-danger"> ' + errormsg + '</div>';
        form.find('legend').html(errormsg);
        return false;
    } else {
        form.find('legend').html('');

        var unique_key  = Date.now();
        var product_url = window.location.href;

        // Calculate grand total
        var grandTotalRaw = productList.reduce(function(sum, p) {
            return sum + (parseInt(p.quantity) * parseInt(p.price.replace(/,/g, '')));
        }, 0);
        var grandTotal = formatPrice(grandTotalRaw);

        // Flat strings for legacy fields
        var productTitles  = productList.map(function(p) { return p.title; }).join(' | ');
        var productQtys    = productList.map(function(p) { return p.quantity; }).join(', ');
        var productTotals  = productList.map(function(p) { return p.total; }).join(', ');
        var variantIds     = productList.map(function(p) { return p.variant_id; }).join(', ');

        // json_payload — products and grand_total only
        var jsonPayload = {
            products:    productList,
            //grand_total: grandTotal
        };

        var dataProducts = {
            name:           jQuery('#cname').val(),
            email:          jQuery('#cemail').val(),
            phone:          jQuery('#cphone').val(),
            state:          jQuery('#cstate').val(),
            enquiry:        jQuery('#enquiry').val(),
            //selectedvalues: '',
            unique_key:     unique_key,
            products:   productList
        };

        // Console log final payload
        console.group('Sending dataProducts');
        console.log(JSON.stringify(dataProducts, null, 2));
        console.groupEnd();

        jQuery.ajax({
            type:        "POST",
            url:         "https://prnt.jasonl.com.au/equipped/Equippedleadsdata/addtoquote",
            data:        dataProducts,
            //contentType: "application/json",
            dataType:    "html",
            beforeSend: function() {
                jQuery('button.submitforpurchase').html('Please wait');
            },
            complete: function() {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event:       'quote_form_submitted',
                    product_url: window.location.href,
                    email:       dataProducts.email || null
                });

                jQuery('.form-container .legend').html(
                    '<div class="alert alert-success"><strong>Success!</strong> Thank you for your inquiry, we will be in touch shortly.</div>'
                );
                document.getElementById("custom_request_purchase").reset();

                setTimeout(function() {
                    jQuery('button.submitforpurchase').html('Submit');
                    jQuery('.form-container .legend').html('');
                }, 3000);
            },
            error: function() {
                console.log('AJAX error — check network tab');
            }
        });
    }

    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }
});